module.exports = __webpack_public_path__ + "img/manchester-city.eb08eb0c.png";